import React from 'react';

function SendIcon(props) {
    return (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.25">
                <path d="M17.4849 3.20665L7.70238 6.45665C1.12655 8.65582 1.12655 12.2417 7.70238 14.43L10.6057 15.3942L11.5699 18.2975C13.7582 24.8733 17.3549 24.8733 19.5432 18.2975L22.8041 8.52582C24.2557 4.13832 21.8724 1.74415 17.4849 3.20665ZM17.8316 9.03499L13.7149 13.1733C13.5524 13.3358 13.3466 13.4117 13.1407 13.4117C12.9349 13.4117 12.7291 13.3358 12.5666 13.1733C12.2524 12.8592 12.2524 12.3392 12.5666 12.025L16.6832 7.88665C16.9974 7.57249 17.5174 7.57249 17.8316 7.88665C18.1457 8.20082 18.1457 8.72082 17.8316 9.03499Z" fill="white"/>
            </g>
        </svg>

    );
}

export default SendIcon;
